<template>
	<div>
		<select v-model="address_id" class="form-control">
			<option :value="null">[Keine Hauptadresse]</option>
			<option v-for="entry in content" :value="entry.id">{{ entry.text }}</option>
		</select>
	</div>
</template>

<script>
import { formatStr } from "root/tools.js"

export default {
	props: {
		"src": Array,
		"value": [String, Number],
		"index": String,
		"format": String
	},

	mounted () {
		this._address_id = this.value
	},

	data () {
		return {
			_address_id: 0,
		}
	},

	computed: {
		address_id: {
			get () {
				// console.log("[CUSTOM-DROPDOWN] address_id (get)", this._address_id)
				return this._address_id
			},

			set (newID) {
				// console.log("[CUSTOM-DROPDOWN] address_id (set)", newID)
				this._address_id = newID
				this.$emit("input", newID)
			}
		},

		content () {
			// console.log("[CUSTOM-DROPDOWN] addresses (get) src:", this.src)

			if (this.src === undefined) {
				return []
			}

			const result = this.src.map(entry => {
				return {
					id: entry[this.index],
					text: formatStr(entry, this.format)
				}
			})

			// console.log("[CUSTOM-DROPDOWN] addresses (get) result:", result)

			return result
		}
	}
}
</script>


// WEBPACK FOOTER //
// custom-select.vue?da79878a